// DEPENDENCIES

import axios from "axios";

import apiHelper from "../helpers/api";
import storeHelper from "../helpers/store";
import utilsHelper from "../helpers/utils";

// INIT

axios.interceptors.request.use(
	async (config) => {
		switch(config.params?.service) {
			case "login":
			break;
			default:
				config.params.access_token = apiHelper.getAccessToken();
			break;
		}

		return config;
	},
	async (error) => {
		return Promise.reject(error);
	}
);

// EXPORT

/**
 * apiRequest - ...
 * 
 * @param {object} options ...
 */
export const apiRequest = (options) => {
	let requestResponse = {};

	options = 
		options || 
		{}
	;

	return axios({
		baseURL: apiHelper.getApiUrl(),
		...options
	}).then((response) => {
		requestResponse = response.data;
	}).catch((error) => {
		requestResponse.error = apiHelper.parseCatchError(error);
	}).then((response) => {
		return requestResponse;
	});
};
